import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { TrendChart } from '../SingleChartView/Trend/TrendChart';
import { getChartConfigForTrends } from './helpers';
import useChartResize from 'sharedHooks/useChartResize';

const KPITrendChartListItem = (props) => {
    const {
        data,
        key,
        from,
        to,
        alertAlarmLimitBackgrounds,
        alertAlarmLimitLines,
        conditionIndicators,
        title,
        loadingStatus,
        conditionStatus,
        zoom,
        unit,
        highErrorValue,
        highAlertLimitValue,
        lowErrorValue,
        lowAlertValue,
        unitGroupId,
        valueType,
        conditionTrendsData,
        conditionForecast,
        sharedXAxisMax,
        sharedForecastSeparatorX,

    } = props.model;

    const containerRef = useRef();
    const chartRef = useRef();

    useChartResize(containerRef, chartRef);

    const trendChartData = useMemo(
        () => getChartConfigForTrends(data, key, title, key, unit, false),
        [data, key, title, unit]
    );

    return (
        <div
            className='conditional-insight-kpi-list'
            ref={containerRef}
        >
            <TrendChart
                title={title}
                actions={{
                    reloadAllSelectedTrendKpiData: props?.actions?.reloadConditionInsights,
                    setIsZoomed: props?.actions?.setIsZoomed,
                    zoomInToSelectedTrendKpiData: props?.actions?.zoomInToSelectedTrendKpiData,
                }}
                model={{
                    selectedTrendKPIs: [key],
                    enableUniqueScaling: false,
                    lastMeasurementTimeStampLabel: title,
                    selectedTrendsData: {
                        loadingStatus: loadingStatus,
                        //data: getChartConfigForTrends(data, key, title, key, unit, true),
                        data: trendChartData,
                        zoom: {
                            isZoomed: zoom,
                            from: from,
                            to: to
                        },
                        chartID: 'op-trendselectedTrendsData-chart',
                    },
                    //userLimits: [3, 5],
                    assetOverAllStatus: conditionStatus,
                    title: title,
                    warningLevels: alertAlarmLimitBackgrounds,
                    warningLines: alertAlarmLimitLines,
                    conditionTrendIndicators: conditionIndicators,
                    highErrorValue: highErrorValue,
                    highAlertLimitValue: highAlertLimitValue,
                    lowErrorValue: lowErrorValue,
                    lowAlertValue: lowAlertValue,
                    unitGroupId: unitGroupId,
                    valueType: valueType,
                    conditionTrendsData: conditionTrendsData,
                    conditionForecast: conditionForecast,
                    sharedXAxisMax: sharedXAxisMax,
                    sharedForecastSeparatorX: sharedForecastSeparatorX,
                }}
                assetId={props.assetId}
                assetDetails={props?.assetDetails}
                chartRef={chartRef}
            />
        </div>
    );
};
KPITrendChartListItem.propTypes = {
    model: PropTypes.shape({
        data: PropTypes.array,
        key: PropTypes.string,
        from: PropTypes.string,
        to: PropTypes.string,
        alertAlarmLimitBackgrounds: PropTypes.array,
        alertAlarmLimitLines: PropTypes.array,
        conditionIndicators: PropTypes.array,
        title: PropTypes.string,
        loadingStatus: PropTypes.string,
        conditionStatus: PropTypes.number,
        zoom: PropTypes.bool,
        unit: PropTypes.string,
        highErrorValue: PropTypes.number,
        highAlertLimitValue: PropTypes.number,
        lowErrorValue: PropTypes.number,
        lowAlertValue: PropTypes.number,
        unitGroupId: PropTypes.number,
        valueType: PropTypes.string,
        conditionTrendsData: PropTypes.array,
        conditionForecast: PropTypes.array,
        sharedXAxisMax: PropTypes.number,
        sharedForecastSeparatorX: PropTypes.number,

    }),
    actions: PropTypes.shape({
        reloadConditionInsights: PropTypes.func,
        setIsZoomed: PropTypes.func,
        zoomInToSelectedTrendKpiData: PropTypes.func
    }),
    assetDetails: PropTypes.object,
    assetId: PropTypes.string
};
// eslint-disable-next-line import/no-unused-modules
export default React.memo(KPITrendChartListItem);
